module.exports = __webpack_public_path__ + "img/logo-cmc vision.a04d188f.svg";